import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";
import { CONTACT } from "../lib/translations";

export default function Kits() {
  const { t } = useLanguage();
  const waFor = (k) => `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(`Hola Amaranto, me interesa el ${k.code} ${k.name}.`)}`;

  return (
    <section id="kits" data-testid="kits-section" className="bg-cream py-28 md:py-40">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-warmbrown" />
              <span className="eyebrow">{t.kits.eyebrow}</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">
              {t.kits.title}
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="font-body italic text-base md:text-lg leading-relaxed text-ink-soft max-w-md">
              {t.kits.sub}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-x-10 gap-y-24 md:gap-y-32">
          {t.kits.items.map((k, i) => (
            <motion.article
              key={k.code}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 1, delay: (i % 2) * 0.08 }}
              data-testid={`kit-card-${i + 1}`}
              className="group"
            >
              <div className="relative overflow-hidden aspect-[4/5] bg-cream-200">
                <img src={k.img} alt={`${k.code} ${k.name}`}
                  className="w-full h-full object-cover transition-transform duration-[1600ms] group-hover:scale-[1.035]" />
                <div className="absolute top-4 left-4 bg-paper/90 backdrop-blur-sm px-3 py-1 border-l-2 border-dustyrose">
                  <span className="eyebrow text-[10px]">{k.code}</span>
                </div>
              </div>

              <div className="mt-8 grid grid-cols-12 gap-4 items-start">
                <div className="col-span-12 md:col-span-7">
                  <h3 className="font-serif text-3xl md:text-4xl text-ink leading-tight">{k.name}</h3>
                  <p className="font-serif italic text-ink-soft text-lg mt-3">{k.tagline}</p>
                </div>
              <div className="col-span-12 md:col-span-5 md:text-right">
                <div className="inline-flex items-baseline gap-2">
                  <span className="block w-2 h-2 bg-dustyrose rounded-full" aria-hidden />
                  <p className="font-serif text-xl text-ink">{k.price}</p>
                </div>
                <p className="font-body text-xs uppercase tracking-[0.22em] text-ink-soft mt-1">{k.shipping}</p>
              </div>
              </div>

              <ul className="mt-6 space-y-2 font-body text-sm text-ink-soft leading-relaxed border-t border-dustyrose/40 pt-6">
                {k.contents.map((c, j) => (
                  <li key={j} className="flex gap-3"><span className="text-dustyrose-deep mt-2 w-1 h-1 rounded-full bg-dustyrose-deep shrink-0" />{c}</li>
                ))}
              </ul>

              <a href={waFor(k)} target="_blank" rel="noreferrer"
                data-testid={`kit-cta-${i + 1}`}
                className="inline-flex items-center gap-3 mt-8 text-[11px] tracking-[0.3em] uppercase font-semibold border-b border-ink pb-1 text-ink hover:text-warmbrown hover:border-warmbrown transition-colors duration-500">
                {t.kits.cta} →
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
